import React from "react";
import "../style/HeroSection.css";

const HeroSection = ({
  title,
  backgroundImage,
  overlayOpacity = 0.5,
  content,
}) => {
  return (
    <div
      className="hero-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Overlay */}
      <div className="hero-overlay" style={{ opacity: overlayOpacity }}></div>

      {/* Text Content */}
      <h2 className="hero-title">{title}</h2>
      <h3 className="hero-content">{content}</h3>
    </div>
  );
};

export default HeroSection;
